import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Compass, Mail, Phone, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { API } from "@/App";

let _settingsCache = null;

export const Footer = () => {
  const { t } = useTranslation();
  const [settings, setSettings] = useState(_settingsCache);

  useEffect(() => {
    if (_settingsCache) return;
    fetch(`${API}/site-settings`).then(r => r.json()).then(d => { _settingsCache = d; setSettings(d); }).catch(() => {});
  }, []);

  return (
    <footer className="relative z-10 border-t border-white/5 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2.5 mb-3">
              <div className="w-8 h-8 rounded-lg bg-purple-700 flex items-center justify-center"><Compass className="w-4 h-4 text-white" /></div>
              <span className="font-inter font-bold">promptviser</span>
            </div>
            <p className="text-white/30 text-xs leading-relaxed">{t("footer.tagline")}</p>
            {settings?.website_url && <a href={settings.website_url} className="text-purple-400 text-xs hover:underline">{settings.website_url.replace("https://", "")}</a>}
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3 text-white/70">{t("footer.legal")}</h4>
            <div className="flex flex-col gap-2 text-sm text-white/40">
              <Link to="/terms" className="hover:text-white transition-colors">{t("footer.terms")}</Link>
              <Link to="/privacy" className="hover:text-white transition-colors">{t("footer.privacy")}</Link>
              <Link to="/refund" className="hover:text-white transition-colors" data-testid="footer-refund-link">{t("footer.refund")}</Link>
              <Link to="/disclaimer" className="hover:text-white transition-colors">{t("footer.disclaimer")}</Link>
              <Link to="/faq" className="hover:text-white transition-colors">FAQ</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-sm mb-3 text-white/70">{t("footer.contact")}</h4>
            <div className="flex flex-col gap-2 text-xs text-white/40" data-testid="footer-contact-info">
              {settings?.address && <span className="flex items-start gap-2"><MapPin className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-purple-400" />{settings.address}</span>}
              {settings?.support_email && <a href={`mailto:${settings.support_email}`} className="flex items-center gap-2 hover:text-white"><Mail className="w-3.5 h-3.5 text-purple-400" />{settings.support_email}</a>}
              {settings?.phone && <a href={`tel:${settings.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 hover:text-white"><Phone className="w-3.5 h-3.5 text-purple-400" />{settings.phone}</a>}
              <Link to="/contact" className="text-purple-400 hover:underline mt-1" data-testid="footer-contact-link">{t("footer.contact_page")}</Link>
            </div>
          </div>
        </div>
        <div className="text-center mt-10 pt-6 border-t border-white/5 text-xs text-white/25">
          &copy; {new Date().getFullYear()} Promptviser. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
